(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordr-after-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nordr-after-banner-landing').forEach((section) => {
    const waitForCartUi = () => new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    const openThemeCart = async () => {
      if (window.Shopify?.actions?.openCart) {
        await window.Shopify.actions.openCart();
        return true;
      }

      const horizonDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (horizonDrawer && typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return true;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return true;
      }

      const trigger = document.querySelector(
        '[data-testid="cart-drawer-trigger"][aria-controls="cart-drawer"], button[aria-controls="cart-drawer"], button[data-cart-drawer-trigger]'
      );
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }

      return false;
    };

    const getFallbackCartSectionIds = () => {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
        if (component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
      });

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.getSectionsToRender === 'function') {
        dawnDrawer.getSectionsToRender().forEach((item) => {
          const id = item?.id || item?.section;
          if (id) sectionIds.add(id);
        });
      }

      if (document.querySelector('theme-drawer#cart-drawer')) {
        sectionIds.add('cart-drawer-section');
      }

      return Array.from(sectionIds).slice(0, 5);
    };

    const renderFallbackCartSections = (payload) => {
      if (!payload?.sections) return;

      const horizonHtml = payload.sections['cart-drawer-section'];
      const horizonWrapper = document.querySelector('#shopify-section-cart-drawer-section');
      if (horizonHtml && horizonWrapper) {
        const parsed = new DOMParser().parseFromString(horizonHtml, 'text/html');
        const nextWrapper = parsed.querySelector('#shopify-section-cart-drawer-section');
        if (nextWrapper) horizonWrapper.innerHTML = nextWrapper.innerHTML;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.renderContents === 'function') {
        dawnDrawer.renderContents(payload);
      }
    };

    const addWithAjaxFallback = async (form) => {
      const cartAddBase = section.dataset.cartAddUrl || form.action;
      const ajaxUrl = cartAddBase.endsWith('.js') ? cartAddBase : `${cartAddBase}.js`;
      const formData = new FormData(form);
      const sectionIds = getFallbackCartSectionIds();

      if (sectionIds.length > 0) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Produkten kunde inte läggas i varukorgen.');
      }

      renderFallbackCartSections(payload);
      await waitForCartUi();
      await openThemeCart();
      return payload;
    };

    section.querySelectorAll('.nordr-after-banner-buy-form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-cart-button-label]');
        const status = form.querySelector('[data-cart-status]');
        const originalLabel = label ? label.textContent : '';

        if (submitButton?.disabled || form.classList.contains('is-loading')) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = Number(formData.get('quantity')) || 1;

        if (!variantId) {
          if (status) {
            status.textContent = 'Produkten kunde inte identifieras. Ladda om sidan och försök igen.';
            status.hidden = false;
          }
          return;
        }

        form.classList.add('is-loading');
        if (submitButton) submitButton.disabled = true;
        if (label) label.textContent = 'Lägger till…';
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }

        try {
          if (window.Shopify?.actions?.updateCart) {
            const result = await window.Shopify.actions.updateCart(
              {
                lines: [{ merchandiseId: String(variantId), quantity }]
              },
              {
                event: {
                  context: 'product',
                  detail: { source: 'nordr-after-banner-premium-landing' }
                }
              }
            );

            if (result?.userErrors?.length) {
              throw new Error(result.userErrors[0].message || 'Produkten kunde inte läggas i varukorgen.');
            }

            if (status && result?.warnings?.length) {
              status.textContent = result.warnings[0].message;
              status.hidden = false;
            }

            await waitForCartUi();
            await openThemeCart();
          } else {
            await addWithAjaxFallback(form);
          }

          if (label) label.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
          if (status && status.hidden) {
            status.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
            status.hidden = false;
          }

          window.setTimeout(() => {
            form.classList.remove('is-loading');
            if (submitButton) submitButton.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 900);
        } catch (error) {
          form.classList.remove('is-loading');
          if (submitButton) submitButton.disabled = false;
          if (label) label.textContent = originalLabel;

          if (status) {
            status.textContent = error instanceof Error ? error.message : 'Något gick fel. Försök igen.';
            status.hidden = false;
          }
        }
      }, true);
    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordr-after-bannerNO"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nordr-after-banner-landing').forEach((section) => {
    const waitForCartUi = () => new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    const openThemeCart = async () => {
      if (window.Shopify?.actions?.openCart) {
        await window.Shopify.actions.openCart();
        return true;
      }

      const horizonDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (horizonDrawer && typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return true;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return true;
      }

      const trigger = document.querySelector(
        '[data-testid="cart-drawer-trigger"][aria-controls="cart-drawer"], button[aria-controls="cart-drawer"], button[data-cart-drawer-trigger]'
      );
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }

      return false;
    };

    const getFallbackCartSectionIds = () => {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
        if (component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
      });

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.getSectionsToRender === 'function') {
        dawnDrawer.getSectionsToRender().forEach((item) => {
          const id = item?.id || item?.section;
          if (id) sectionIds.add(id);
        });
      }

      if (document.querySelector('theme-drawer#cart-drawer')) {
        sectionIds.add('cart-drawer-section');
      }

      return Array.from(sectionIds).slice(0, 5);
    };

    const renderFallbackCartSections = (payload) => {
      if (!payload?.sections) return;

      const horizonHtml = payload.sections['cart-drawer-section'];
      const horizonWrapper = document.querySelector('#shopify-section-cart-drawer-section');
      if (horizonHtml && horizonWrapper) {
        const parsed = new DOMParser().parseFromString(horizonHtml, 'text/html');
        const nextWrapper = parsed.querySelector('#shopify-section-cart-drawer-section');
        if (nextWrapper) horizonWrapper.innerHTML = nextWrapper.innerHTML;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.renderContents === 'function') {
        dawnDrawer.renderContents(payload);
      }
    };

    const addWithAjaxFallback = async (form) => {
      const cartAddBase = section.dataset.cartAddUrl || form.action;
      const ajaxUrl = cartAddBase.endsWith('.js') ? cartAddBase : `${cartAddBase}.js`;
      const formData = new FormData(form);
      const sectionIds = getFallbackCartSectionIds();

      if (sectionIds.length > 0) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Produktet kunne ikke legges i handlekurven.');
      }

      renderFallbackCartSections(payload);
      await waitForCartUi();
      await openThemeCart();
      return payload;
    };

    section.querySelectorAll('.nordr-after-banner-buy-form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-cart-button-label]');
        const status = form.querySelector('[data-cart-status]');
        const originalLabel = label ? label.textContent : '';

        if (submitButton?.disabled || form.classList.contains('is-loading')) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = Number(formData.get('quantity')) || 1;

        if (!variantId) {
          if (status) {
            status.textContent = 'Produktet kunne ikke identifiseres. Last inn siden på nytt og prøv igjen.';
            status.hidden = false;
          }
          return;
        }

        form.classList.add('is-loading');
        if (submitButton) submitButton.disabled = true;
        if (label) label.textContent = 'Legger til…';
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }

        try {
          if (window.Shopify?.actions?.updateCart) {
            const result = await window.Shopify.actions.updateCart(
              {
                lines: [{ merchandiseId: String(variantId), quantity }]
              },
              {
                event: {
                  context: 'product',
                  detail: { source: 'nordr-after-banner-premium-landing' }
                }
              }
            );

            if (result?.userErrors?.length) {
              throw new Error(result.userErrors[0].message || 'Produktet kunne ikke legges i handlekurven.');
            }

            if (status && result?.warnings?.length) {
              status.textContent = result.warnings[0].message;
              status.hidden = false;
            }

            await waitForCartUi();
            await openThemeCart();
          } else {
            await addWithAjaxFallback(form);
          }

          if (label) label.textContent = section.dataset.cartSuccess || 'Lagt i handlekurven';
          if (status && status.hidden) {
            status.textContent = section.dataset.cartSuccess || 'Lagt i handlekurven';
            status.hidden = false;
          }

          window.setTimeout(() => {
            form.classList.remove('is-loading');
            if (submitButton) submitButton.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 900);
        } catch (error) {
          form.classList.remove('is-loading');
          if (submitButton) submitButton.disabled = false;
          if (label) label.textContent = originalLabel;

          if (status) {
            status.textContent = error instanceof Error ? error.message : 'Noe gikk galt. Prøv igjen.';
            status.hidden = false;
          }
        }
      }, true);
    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordr-afterbanner-tvalval"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nordr-after-banner-landing').forEach((section) => {
    const waitForCartUi = () => new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    const openThemeCart = async () => {
      if (window.Shopify?.actions?.openCart) {
        await window.Shopify.actions.openCart();
        return true;
      }

      const horizonDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (horizonDrawer && typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return true;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return true;
      }

      const trigger = document.querySelector(
        '[data-testid="cart-drawer-trigger"][aria-controls="cart-drawer"], button[aria-controls="cart-drawer"], button[data-cart-drawer-trigger]'
      );
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }

      return false;
    };

    const getFallbackCartSectionIds = () => {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
        if (component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
      });

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.getSectionsToRender === 'function') {
        dawnDrawer.getSectionsToRender().forEach((item) => {
          const id = item?.id || item?.section;
          if (id) sectionIds.add(id);
        });
      }

      if (document.querySelector('theme-drawer#cart-drawer')) {
        sectionIds.add('cart-drawer-section');
      }

      return Array.from(sectionIds).slice(0, 5);
    };

    const renderFallbackCartSections = (payload) => {
      if (!payload?.sections) return;

      const horizonHtml = payload.sections['cart-drawer-section'];
      const horizonWrapper = document.querySelector('#shopify-section-cart-drawer-section');
      if (horizonHtml && horizonWrapper) {
        const parsed = new DOMParser().parseFromString(horizonHtml, 'text/html');
        const nextWrapper = parsed.querySelector('#shopify-section-cart-drawer-section');
        if (nextWrapper) horizonWrapper.innerHTML = nextWrapper.innerHTML;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.renderContents === 'function') {
        dawnDrawer.renderContents(payload);
      }
    };

    const addWithAjaxFallback = async (form) => {
      const cartAddBase = section.dataset.cartAddUrl || form.action;
      const ajaxUrl = cartAddBase.endsWith('.js') ? cartAddBase : `${cartAddBase}.js`;
      const formData = new FormData(form);
      const sectionIds = getFallbackCartSectionIds();

      if (sectionIds.length > 0) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Produkten kunde inte läggas i varukorgen.');
      }

      renderFallbackCartSections(payload);
      await waitForCartUi();
      await openThemeCart();
      return payload;
    };

    section.querySelectorAll('.nordr-after-banner-buy-form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-cart-button-label]');
        const status = form.querySelector('[data-cart-status]');
        const originalLabel = label ? label.textContent : '';

        if (submitButton?.disabled || form.classList.contains('is-loading')) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = Number(formData.get('quantity')) || 1;

        if (!variantId) {
          if (status) {
            status.textContent = 'Produkten kunde inte identifieras. Ladda om sidan och försök igen.';
            status.hidden = false;
          }
          return;
        }

        form.classList.add('is-loading');
        if (submitButton) submitButton.disabled = true;
        if (label) label.textContent = 'Lägger till…';
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }

        try {
          if (window.Shopify?.actions?.updateCart) {
            const result = await window.Shopify.actions.updateCart(
              {
                lines: [{ merchandiseId: String(variantId), quantity }]
              },
              {
                event: {
                  context: 'product',
                  detail: { source: 'nordr-after-banner-premium-landing' }
                }
              }
            );

            if (result?.userErrors?.length) {
              throw new Error(result.userErrors[0].message || 'Produkten kunde inte läggas i varukorgen.');
            }

            if (status && result?.warnings?.length) {
              status.textContent = result.warnings[0].message;
              status.hidden = false;
            }

            await waitForCartUi();
            await openThemeCart();
          } else {
            await addWithAjaxFallback(form);
          }

          if (label) label.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
          if (status && status.hidden) {
            status.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
            status.hidden = false;
          }

          window.setTimeout(() => {
            form.classList.remove('is-loading');
            if (submitButton) submitButton.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 900);
        } catch (error) {
          form.classList.remove('is-loading');
          if (submitButton) submitButton.disabled = false;
          if (label) label.textContent = originalLabel;

          if (status) {
            status.textContent = error instanceof Error ? error.message : 'Något gick fel. Försök igen.';
            status.hidden = false;
          }
        }
      }, true);
    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordr-premium-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nordr-landing').forEach((section) => {
    const gallery = section.querySelector('[data-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('.nordr-thumb'));
      let activeIndex = 0;
      let scrollFrame = null;
      let isDragging = false;
      let didDrag = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let activePointerId = null;

      const updateThumbs = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      };

      const showImage = (index, behavior = 'smooth') => {
        if (!track || slides.length === 0) return;
        const normalizedIndex = (index + slides.length) % slides.length;
        updateThumbs(normalizedIndex);
        track.scrollTo({ left: track.clientWidth * normalizedIndex, behavior });
      };

      thumbs.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

      if (track && slides.length > 1) {
        track.addEventListener('scroll', () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            const width = track.clientWidth || 1;
            const nextIndex = Math.round(track.scrollLeft / width);
            if (nextIndex !== activeIndex) updateThumbs(nextIndex);
          });
        }, { passive: true });

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          isDragging = true;
          didDrag = false;
          activePointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartScrollLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture?.(event.pointerId);
        });

        track.addEventListener('pointermove', (event) => {
          if (!isDragging || event.pointerId !== activePointerId) return;
          const deltaX = event.clientX - dragStartX;
          if (Math.abs(deltaX) > 4) didDrag = true;
          track.scrollLeft = dragStartScrollLeft - deltaX;
          event.preventDefault();
        });

        const endDrag = (event) => {
          if (!isDragging || (activePointerId !== null && event.pointerId !== activePointerId)) return;
          isDragging = false;
          track.classList.remove('is-dragging');
          try { track.releasePointerCapture?.(event.pointerId); } catch (error) {}
          activePointerId = null;
          const width = track.clientWidth || 1;
          const nearestIndex = Math.round(track.scrollLeft / width);
          showImage(nearestIndex);
        };

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('dragstart', (event) => event.preventDefault());
        track.addEventListener('click', (event) => {
          if (didDrag) {
            event.preventDefault();
            event.stopPropagation();
            didDrag = false;
          }
        }, true);

        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showImage(activeIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showImage(activeIndex + 1);
          }
        });

        let previousWidth = track.clientWidth;
        const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => {
          if (track.clientWidth !== previousWidth) {
            previousWidth = track.clientWidth;
            track.scrollTo({ left: track.clientWidth * activeIndex, behavior: 'auto' });
          }
        }) : null;
        resizeObserver?.observe(track);
      }
    }

    const waitForCartUi = () => new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    const openThemeCart = async () => {
      if (window.Shopify?.actions?.openCart) {
        await window.Shopify.actions.openCart();
        return true;
      }

      const horizonDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (horizonDrawer && typeof horizonDrawer.open === 'function') {
        horizonDrawer.open();
        return true;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function') {
        dawnDrawer.open();
        return true;
      }

      const trigger = document.querySelector(
        '[data-testid="cart-drawer-trigger"][aria-controls="cart-drawer"], button[aria-controls="cart-drawer"], button[data-cart-drawer-trigger]'
      );
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }

      return false;
    };

    const getFallbackCartSectionIds = () => {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
        if (component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
      });

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.getSectionsToRender === 'function') {
        dawnDrawer.getSectionsToRender().forEach((item) => {
          const id = item?.id || item?.section;
          if (id) sectionIds.add(id);
        });
      }

      if (document.querySelector('theme-drawer#cart-drawer')) {
        sectionIds.add('cart-drawer-section');
      }

      return Array.from(sectionIds).slice(0, 5);
    };

    const renderFallbackCartSections = (payload) => {
      if (!payload?.sections) return;

      const horizonHtml = payload.sections['cart-drawer-section'];
      const horizonWrapper = document.querySelector('#shopify-section-cart-drawer-section');
      if (horizonHtml && horizonWrapper) {
        const parsed = new DOMParser().parseFromString(horizonHtml, 'text/html');
        const nextWrapper = parsed.querySelector('#shopify-section-cart-drawer-section');
        if (nextWrapper) horizonWrapper.innerHTML = nextWrapper.innerHTML;
      }

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.renderContents === 'function') {
        dawnDrawer.renderContents(payload);
      }
    };

    const addWithAjaxFallback = async (form) => {
      const cartAddBase = section.dataset.cartAddUrl || form.action;
      const ajaxUrl = cartAddBase.endsWith('.js') ? cartAddBase : `${cartAddBase}.js`;
      const formData = new FormData(form);
      const sectionIds = getFallbackCartSectionIds();

      if (sectionIds.length > 0) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Produkten kunde inte läggas i varukorgen.');
      }

      renderFallbackCartSections(payload);
      await waitForCartUi();
      await openThemeCart();
      return payload;
    };

    section.querySelectorAll('.nordr-buy-form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-cart-button-label]');
        const status = form.querySelector('[data-cart-status]');
        const originalLabel = label ? label.textContent : '';

        if (submitButton?.disabled || form.classList.contains('is-loading')) return;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = Number(formData.get('quantity')) || 1;

        if (!variantId) {
          if (status) {
            status.textContent = 'Produkten kunde inte identifieras. Ladda om sidan och försök igen.';
            status.hidden = false;
          }
          return;
        }

        form.classList.add('is-loading');
        if (submitButton) submitButton.disabled = true;
        if (label) label.textContent = 'Lägger till…';
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }

        try {
          if (window.Shopify?.actions?.updateCart) {
            const result = await window.Shopify.actions.updateCart(
              {
                lines: [{ merchandiseId: String(variantId), quantity }]
              },
              {
                event: {
                  context: 'product',
                  detail: { source: 'nordr-premium-landing' }
                }
              }
            );

            if (result?.userErrors?.length) {
              throw new Error(result.userErrors[0].message || 'Produkten kunde inte läggas i varukorgen.');
            }

            if (status && result?.warnings?.length) {
              status.textContent = result.warnings[0].message;
              status.hidden = false;
            }

            await waitForCartUi();
            await openThemeCart();
          } else {
            await addWithAjaxFallback(form);
          }

          if (label) label.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
          if (status && status.hidden) {
            status.textContent = section.dataset.cartSuccess || 'Tillagd i varukorgen';
            status.hidden = false;
          }

          window.setTimeout(() => {
            form.classList.remove('is-loading');
            if (submitButton) submitButton.disabled = false;
            if (label) label.textContent = originalLabel;
          }, 900);
        } catch (error) {
          form.classList.remove('is-loading');
          if (submitButton) submitButton.disabled = false;
          if (label) label.textContent = originalLabel;

          if (status) {
            status.textContent = error instanceof Error ? error.message : 'Något gick fel. Försök igen.';
            status.hidden = false;
          }
        }
      }, true);
    });

    const sticky = section.querySelector('[data-sticky-buy]');
    const heroCta = section.querySelector('.nordr-hero .nordr-cta');
    if (sticky && heroCta && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.15 });
      observer.observe(heroCta);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordr_soap_guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nordr-soap-guide')) {
  customElements.define('nordr-soap-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.items = Array.from(this.querySelectorAll('.nsg__faq'));
      this.initialOpen = new Map(this.items.map(item => [item, item.open]));
      this.search = this.querySelector('[data-search]');
      this.category = 'all';
      this.previousQuery = '';
      this.normalise = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ');
      this.stopWords = new Set(['hur', 'vad', 'var', 'kan', 'jag', 'min', 'mitt', 'mina', 'en', 'ett', 'den', 'det', 'ar', 'ska', 'far', 'med', 'och', 'pa', 'till', 'hos', 'how', 'what', 'where', 'why', 'do', 'does', 'can', 'i', 'my', 'the', 'a', 'an', 'is', 'should', 'of']);
      this.items.forEach(item => { item.searchText = this.normalise(item.textContent + ' ' + item.dataset.keywords); });
      this.search?.addEventListener('input', () => this.filterItems(), { signal });
      this.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.category;
        this.syncCategories();
        this.filterItems();
      }, { signal }));
      this.querySelector('[data-reset]')?.addEventListener('click', () => {
        this.resetFilter();
        this.search?.focus();
      }, { signal });
      this.querySelector('[data-expand]')?.addEventListener('click', () => {
        const visible = this.items.filter(item => !item.hidden);
        const open = !visible.every(item => item.open);
        visible.forEach(item => { item.open = open; });
        this.syncExpand();
      }, { signal });
      this.addEventListener('toggle', event => {
        if (event.target.classList.contains('nsg__faq')) this.syncExpand();
      }, { signal, capture: true });
      this.querySelector('[data-calculator]')?.addEventListener('submit', event => {
        event.preventDefault();
        this.calculate();
      }, { signal });
      this.querySelector('[data-calculator]')?.addEventListener('input', () => {
        const output = this.querySelector('[data-result]');
        if (output) output.hidden = true;
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.nsg__faq');
        if (item && this.contains(item)) {
          this.resetFilter();
          item.open = true;
          this.syncExpand();
        }
      }, { signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (link) this.openHash(link.hash, false);
      }, { signal });
      window.addEventListener('hashchange', () => this.openHash(window.location.hash, true), { signal });
      this.classList.add('is-enhanced');
      this.syncCategories();
      this.filterItems();
      this.openHash(window.location.hash, true);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    syncCategories() {
      this.querySelectorAll('[data-category]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.category === this.category));
      });
    }
    resetFilter() {
      if (this.search) this.search.value = '';
      this.category = 'all';
      this.syncCategories();
      this.filterItems();
    }
    filterItems() {
      const query = this.normalise(this.search?.value || '').trim();
      const words = query.split(/\s+/).filter(Boolean);
      const meaningfulWords = words.filter(word => !this.stopWords.has(word));
      const tokens = meaningfulWords.length ? meaningfulWords : words;
      let count = 0;
      this.items.forEach(item => {
        const categoryMatches = this.category === 'all' || item.dataset.topic === this.category;
        const queryMatches = tokens.every(token => item.searchText.includes(token));
        const matches = categoryMatches && queryMatches;
        item.hidden = !matches;
        if (matches) count += 1;
        if (query) item.open = matches;
        else if (this.previousQuery) item.open = this.initialOpen.get(item);
      });
      this.previousQuery = query;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = count !== 0;
      const status = this.querySelector('[data-count-status]');
      if (status) status.textContent = (count === 1 ? this.dataset.countOne : this.dataset.count).replace('[count]', String(count));
      this.syncExpand();
    }
    syncExpand() {
      const button = this.querySelector('[data-expand]');
      if (!button) return;
      const visible = this.items.filter(item => !item.hidden);
      const expanded = visible.length > 0 && visible.every(item => item.open);
      button.disabled = visible.length === 0;
      button.setAttribute('aria-expanded', String(expanded));
      button.querySelector('[data-open-label]').hidden = expanded;
      button.querySelector('[data-close-label]').hidden = !expanded;
    }
    openHash(hash, scroll) {
      if (!hash) return;
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      const item = this.items.find(candidate => candidate.id === id);
      if (!item) return;
      this.resetFilter();
      item.open = true;
      this.syncExpand();
      if (scroll) item.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    calculate() {
      const form = this.querySelector('[data-calculator]');
      if (!form || !form.reportValidity()) return;
      const start = Number(this.querySelector('[data-start]').value);
      const current = Number(this.querySelector('[data-current]').value);
      const days = Number(this.querySelector('[data-days]').value);
      const output = this.querySelector('[data-result]');
      const total = this.querySelector('[data-result-total]');
      const remaining = this.querySelector('[data-result-remaining]');
      let error = '';
      if (![start, current, days].every(Number.isFinite) || start <= 0 || current < 0 || current > start || days <= 0) error = this.dataset.calcError;
      else if (current === start) error = this.dataset.calcUnchanged;
      output.hidden = false;
      output.classList.toggle('is-error', Boolean(error));
      if (error) {
        total.textContent = error;
        remaining.textContent = '';
        return;
      }
      const dailyUse = (start - current) / days;
      const weeks = start / dailyUse / 7;
      const daysRemaining = current / dailyUse;
      const locale = this.dataset.locale || 'sv';
      const format = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });
      const plurals = new Intl.PluralRules(locale, { maximumFractionDigits: 1 });
      const totalTemplate = plurals.select(weeks) === 'one' ? this.dataset.totalOne : this.dataset.total;
      const remainingTemplate = plurals.select(daysRemaining) === 'one' ? this.dataset.remainingOne : this.dataset.remaining;
      total.textContent = totalTemplate.replace('[weeks]', format.format(weeks));
      remaining.textContent = remainingTemplate.replace('[days]', format.format(daysRemaining));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
